export default [
    {
        name: 'cadastro-pais',
        path: 'pais',
        redirect: 'pais/index',
        component: () => import(/* webpackChunkName: 'cadastro-pais' */ '@/views/cadastro/pais/Index'),
        children: [
            {
                meta: {title: 'Lista de países'},
                name: 'cadastro-pais-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-pais' */ '@/views/cadastro/pais/List.vue'),
            },
        ],
    },
]